import {
  KEYCLOAK_URL,
  BASE_URL,
  AUTH_TYPE,
  KEYCLOAK_APP_ID,
  KEYCLOAK_REDIRECT_URL,
  KEYCLOAK_REALM
} from 'config'
import { synapse, appReadyStore, userStore, modalStore } from 'state'
import { openModal } from 'components/Modal/actions'
import UbliqueKeycloak from './components/UbliqueKeycloak'

let keyCloakOauth2Login
const baseUpdatePassword = () => {
  const { activeModals } = modalStore.get()
  if (!activeModals.includes('password')) {
    openModal('password')
  }
}
const keyCloakprops = {
  clientId: KEYCLOAK_APP_ID,
  url: KEYCLOAK_URL,
  redirectUri: KEYCLOAK_REDIRECT_URL,
  realm: KEYCLOAK_REALM
}

const base = {
  updatePassword: baseUpdatePassword,
  login: wrapLogin((username, password) => {
    return synapse.auth.login(`${BASE_URL}/authentication/signin`, {
      authParams: { username, password }
    })
  }),
  logout: wrapLogout(() => synapse.auth.logout()),
  refreshToken() {
    return synapse.auth.refreshToken(`${BASE_URL}/authentication/refreshtoken`, {fetchOptions: {retry: 0}})
  }
}

// rinominare poi la variabile di env come oauth2
const oauth2 = {
  updatePassword: baseUpdatePassword,
  login: wrapLogin((username, password) => {
    return synapse.auth.login(KEYCLOAK_URL, {
      authParams: {
        client_id: KEYCLOAK_APP_ID,
        grant_type: 'password',
        username,
        password
      }
    })
  }),
  logout: wrapLogout(() => synapse.auth.logout()),
  refreshToken() {
    return synapse.auth.refreshToken(KEYCLOAK_URL, {
      authParams: { client_id: KEYCLOAK_APP_ID }
    })
  }
}

const keycloakOauth2 = {
  login: wrapLogin(() => {
    return wrapLoginOauth2KC(synapse.auth.loginKC)
  }),
  logout: wrapLogout(() => {
    return wrapLogoutOauth2KC(synapse.auth.logout)
  }),
  updatePassword: () => wrapPasswordOauth2KC(),
  refreshToken() {
    return synapse.auth.refreshToken(KEYCLOAK_URL, {
      authParams: { client_id: KEYCLOAK_APP_ID }
    })
  }
}

function wrapLogin(login) {
  return async (...args) => {
    await login(...args)
    const user = await synapse.user()
    userStore.set(user)
  }
}

function wrapLogout(logout) {
  return async () => {
    await logout()
    const user = await synapse.user()
    userStore.set(user)
    appReadyStore.set(false)
  }
}

// KEYCLOAK OAUTH2
const wrapLoginOauth2KC = (loginCallback) => {
  keyCloakOauth2Login = new UbliqueKeycloak(keyCloakprops)
  keyCloakOauth2Login.ubliqueLogin(loginCallback)
}

const wrapLogoutOauth2KC = (logoutUpdateStoreCallback) => {
  if (!keyCloakOauth2Login) {
    keyCloakOauth2Login = new UbliqueKeycloak(keyCloakprops)
  }
  keyCloakOauth2Login.ubliqueLogout(logoutUpdateStoreCallback)
}

const wrapPasswordOauth2KC = () => {
  if (!keyCloakOauth2Login) {
    keyCloakOauth2Login = new UbliqueKeycloak(keyCloakprops)
  }
  keyCloakOauth2Login.ubliqueUpdatePassword()
}

const authTypes = { base, keycloak: oauth2, keycloakOauth2 }

export const {
  login,
  logout,
  refreshToken,
  updatePassword,
  type = AUTH_TYPE
} = authTypes[AUTH_TYPE]
